import { property, array, defaultVal, optional } from 'class-converter';
import moment from 'moment'

export class RefEspece {
    @property('id', null, true) id;
    @property('code', null, true) code;
    @property('libelle', null, true) libelle;
    @property('codeCommun', null, true) codeCommun;
    @property('codeEspece', null, true) codeEspece;
}
export class RefTypeTransformation {
    @property('id', null, true) id;
    @property('code', null, true) code;
    @property('nom', null, true) nom;
}

export class SourceEspeceView {
    @property('id', null, true) id;
    @property('disponible', null, true) disponible;
    @property('poidCD', null, true) poidCD;
    @property('poidExporte', null, true) poidExporte;
    @property('codeSH', null, true) codeSH = "";
    @property('autreTypeTransf', null, true) autreTypeTransf = "";
    @property('observations', null, true) observations = "";
    @property('imprime', null, true) imprime;
    @property('rendementG', null, true) rendementG;
    @property('rendementT', null, true) rendementT;
    @property('sourceDetail', null, true) sourceDetail;
    @property('id_RefEspece', null, true) id_RefEspece;
    @property('libelleEspece', null, true) libelleEspece;
    @property('id_RefTypeTransf', null, true) id_RefTypeTransf;
    @property('refEspece', RefEspece) refEspece;
    @property('refTypeTransf', RefTypeTransformation) refTypeTransf;
    @property('id_RefSourceEspeceCCSrc', null, true) id_RefSourceEspeceCCSrc;
    @property('id_RefSourceEspeceCPSrc', null, true) id_RefSourceEspeceCPSrc;
    @property('id_refDeclaration', null, true) id_refDeclaration;
    @property('categoriePeche', null, true) categoriePeche;
    @property('navire', null, true) navire;
    @defaultVal(false) @property('selected', null, true) selected;
}
export class SourceEXView {
    @property('id', null, true) id;
    @property('cc', null, true) cc;
    @property('id_RefSrc', null, true) id_RefSrc;
    @property('id_RefTypeSource', null, true) id_RefTypeSource;
    @property('cp', null, true) cp;
    @property('codeSource', null, true) codeSource = "";
    @property('typeSource', null, true) typeSource = "";
    @array() @property('childrenSrcEsp', SourceEspeceView) childrenSrcEsp;
    @array() @optional() @property('allChildrenSrcEsp', SourceEspeceView) allChildrenSrcEsp = [];
    @array() @optional() @property('sourceEXPList') sourceEXPList = [];
}
export class CessionExportView {
    @property('id', null, true) id;
    @property('numeroCessionComplet', null, true) numeroCessionComplet = null;
    @property('dateCession', null, true) dateCession = moment().format("DD/MM/YYYY");
    @property('dateSysteme', null, true) dateSysteme = moment().format("DD/MM/YYYY");
    @property('dpmValid', null, true) dpmValid = null;
    @property('etat', null, true) etat = null;
    @property('numeroCertificat', null, true) numeroCertificat = "";
    @property('certificatManuelle', null, true) certificatManuelle = false;
    @property('dateVisa', null, true) dateVisa = null;
    @property('lieuDepart', null, true) lieuDepart = null;
    @property('numeroVol', null, true) numeroVol = null;
    @property('numeroVoitureFerro', null, true) numeroVoitureFerro = null;
    @property('autreDocs', null, true) autreDocs = null;
    @property('numeroConteneur', null, true) numeroConteneur = null;
    @property('numeroCertificatVeterinaire', null, true) numeroCertificatVeterinaire = null;
    @property('nomImportateur', null, true) nomImportateur = null;
    @property('auditLabelDesc', null, true) auditLabelDesc = null;
    @property('id_RefDpmValid', null, true) id_RefDpmValid = null;
    @property('id_RefPaysExp', null, true) id_RefPaysExp = null;
    @property('categoriePeche', null, true) categoriePeche = "";
    @optional() @property('refPaysExp', null, true) refPaysExp = null;
    @array() @property("childrenSourceEXP", SourceEXView) childrenSourceEXP = [];
}

export default class CessionExport {
    @property('id', null, true) id;
    @property('numeroCessionComplet', null, true) numeroCessionComplet;
    @property('dateCession', null, true) dateCession;
    @defaultVal(new Date()) @property('dateSysteme', null, true) dateSysteme;
    @property('etat', null, true) etat;
    @property('dpmValid', null, true) dpmValid;

}

